import { render, staticRenderFns } from "./ReportF.vue?vue&type=template&id=2d51509e&scoped=true&"
import script from "./ReportF.vue?vue&type=script&lang=js&"
export * from "./ReportF.vue?vue&type=script&lang=js&"
import style0 from "./ReportF.vue?vue&type=style&index=0&id=2d51509e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d51509e",
  null
  
)

export default component.exports